import { render, staticRenderFns } from "./internationalProductList.vue?vue&type=template&id=0b1ef21a&scoped=true"
import script from "./internationalProductList.vue?vue&type=script&lang=js"
export * from "./internationalProductList.vue?vue&type=script&lang=js"
import style0 from "./internationalProductList.vue?vue&type=style&index=0&id=0b1ef21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ef21a",
  null
  
)

export default component.exports